<script setup lang="ts">
import ExternalIcon from '~/components/design-system/icons/ExternalIcon.vue';
import type { LoggedIn, LoggedOut } from '~/interfaces/dto/config/response';

const auth = useAuthStore();
const settings = useSiteStore();
const emits = defineEmits(['toggleHamburger']);

const hamburgerOptions = computed(() =>
  settings.config?.devConfig?.hamburgerMenu?.flatMap((menuOption) => {
    if (auth.loggedIn) return menuOption.loggedIn;
    if (!!menuOption.loggedOut) return menuOption.loggedOut;
    return [];
  }),
);

function handleItemClick(item: LoggedIn | LoggedOut) {
  emits('toggleHamburger');
  useMessageHandler({ action: item.Action, actionValue: item.Value });
}
</script>

<template>
  <div v-if="hamburgerOptions?.length > 0" class="grid grid-cols-2 gap-2 mb-4">
    <div v-for="(item, index) in hamburgerOptions" :key="index">
      <div
        :class="[
          settings.region.toLowerCase() === 'za'
            ? 'primary-bg-za'
            : 'primary-bg-roa',
          'hamburger-account-options',
        ]"
        @click="handleItemClick(item)"
      >
        <ExternalIcon class="w-4 h-4 !mx-2" :icon-name="item?.Text" />
        <span class="truncate">
          {{ $t(item?.Text) }}
        </span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.hamburger-account-options {
  @apply rounded-lg font-bold text-xs flex items-center text-dark-700 dark:text-light-50 capitalize py-2 cursor-pointer;
}

.primary-bg {
  &-za {
    @apply bg-primary-blue-100 dark:bg-[#00183B];
  }
  &-roa {
    @apply bg-primary-pink-100 dark:bg-primary-pink-1300;
  }
}
</style>
